var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Light-S"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.117 9.42738C8.7831 9.42738 7.6705 8.9781 6.7792 8.07954C5.88813 7.18075 5.44259 6.0588 5.44259 4.71369C5.44259 3.36858 5.88813 2.24663 6.7792 1.34784C7.6705 0.44928 8.7831 0 10.117 0C11.4509 0 12.5635 0.44928 13.4548 1.34784C14.3459 2.24663 14.7914 3.36858 14.7914 4.71369C14.7914 6.0588 14.3459 7.18075 13.4548 8.07954C12.5635 8.9781 11.4509 9.42738 10.117 9.42738ZM2.16234 19.7178C1.55453 19.7178 1.04218 19.5075 0.625309 19.0869C0.208436 18.6665 0 18.1499 0 17.537V16.6227C0 15.9406 0.183157 15.3241 0.549472 14.7733C0.916013 14.2226 1.39631 13.8073 1.99036 13.5276C3.28837 12.9199 4.62566 12.4529 6.00222 12.1265C7.379 11.8001 8.7506 11.6369 10.117 11.6369C11.4834 11.6369 12.8605 11.8001 14.2484 12.1265C15.6362 12.4529 16.968 12.9199 18.2436 13.5276C18.8377 13.8073 19.318 14.2226 19.6845 14.7733C20.0508 15.3241 20.234 15.9406 20.234 16.6227V17.537C20.234 18.1499 20.0256 18.6665 19.6087 19.0869C19.1918 19.5075 18.6795 19.7178 18.0717 19.7178H2.16234Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthUser);
export default __webpack_public_path__ + "static/media/auth-user.72bc7aba934478486bacb68324b1a1b7.svg";
export { ForwardRef as ReactComponent };